import { AdChannel } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IAdSpendVolumeFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";

import * as columnNames from "../../constants/column-names";

type AdSpendVolumeColumnMapping = {
    readonly spend: readonly SuggestedColumnName[];
    readonly activeCampaigns: readonly SuggestedColumnName[];
    readonly adsNumber: readonly SuggestedColumnName[];
    readonly mobileShare: readonly SuggestedColumnName[];
};

const COLUMNS_BY_CHANNEL: Record<AdChannel, AdSpendVolumeColumnMapping> = {
    [AdChannel.Total]: {
        spend: [columnNames.TOTAL_AD_SPEND_FIELD, columnNames.TOTAL_AD_SPEND_CHANGE_MOM_FIELD],
        activeCampaigns: [columnNames.TOTAL_AD_ACTIVE_CAMPAIGNS_FIELD],
        adsNumber: [columnNames.TOTAL_AD_NUMBER_FIELD],
        mobileShare: [columnNames.TOTAL_ADS_DESKTOP_SHARE_FIELD, columnNames.TOTAL_ADS_MOBILE_SHARE_FIELD],
    },
    [AdChannel.Search]: {
        spend: [columnNames.SEARCH_AD_SPEND_FIELD, columnNames.SEARCH_AD_SPEND_CHANGE_MOM_FIELD],
        activeCampaigns: [columnNames.SEARCH_AD_ACTIVE_CAMPAIGNS_FIELD],
        adsNumber: [columnNames.SEARCH_AD_NUMBER_FIELD],
        mobileShare: [columnNames.SEARCH_ADS_DESKTOP_SHARE_FIELD, columnNames.SEARCH_ADS_MOBILE_SHARE_FIELD],
    },
    [AdChannel.Display]: {
        spend: [columnNames.DISPLAY_AD_SPEND_FIELD, columnNames.DISPLAY_AD_SPEND_CHANGE_MOM_FIELD],
        activeCampaigns: [columnNames.DISPLAY_AD_ACTIVE_CAMPAIGNS_FIELD],
        adsNumber: [columnNames.DISPLAY_AD_NUMBER_FIELD],
        mobileShare: [columnNames.DISPLAY_ADS_DESKTOP_SHARE_FIELD, columnNames.DISPLAY_ADS_MOBILE_SHARE_FIELD],
    },
};

const processAdSpendVolumeFilter = (filterDto: Partial<IAdSpendVolumeFilterDto>): readonly SuggestedColumnName[] => {
    const channel = filterDto.channel ?? AdChannel.Total;
    const channelMapping = COLUMNS_BY_CHANNEL[channel];

    if (!channelMapping) {
        return [];
    }

    const columns: SuggestedColumnName[] = [];

    if (filterDto.spend) {
        columns.push(...channelMapping.spend);
    }

    if (filterDto.activeCampaigns) {
        columns.push(...channelMapping.activeCampaigns);
    }

    if (filterDto.adsNumber) {
        columns.push(...channelMapping.adsNumber);
    }

    if (filterDto.mobileShare) {
        columns.push(...channelMapping.mobileShare);
    }

    return columns;
};

export default processAdSpendVolumeFilter;
